export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const GET_ERROR_MESSAGE = "GET_ERROR_MESSAGE";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const UPDATE_EXPERIENCE = "UPDATE_EXPERIENCE";
export const GET_EXPERIENCE = "GET_EXPERIENCE";
export const GET_EXPERIENCE_VIEW = "GET_EXPERIENCE_VIEW";
export const ADD_EXPERIENCE = "ADD_EXPERIENCE";
export const UPDATE_EDUCATION = "UPDATE_EDUCATION";
export const ADD_EDUCATION = "ADD_EDUCATION";
export const UPDATE_LICENSES = "UPDATE_LICENSES";
export const ADD_LICENSES = "ADD_LICENSES";
export const UPDATE_VOLUNTEER = "UPDATE_VOLUNTEER";
export const ADD_VOLUNTEER = "ADD_VOLUNTEER";
export const GET_MODEL_SKILLS = "GET_MODEL_SKILLS";
export const UPDATE_SKILLS = "UPDATE_SKILLS";
export const GET_INTERESTS = "GET_INTERESTS";
export const GET_INTERESTS_VIEW = "GET_INTERESTS_VIEW";
export const GET_MODEL_INTERESTS = "GET_MODEL_INTERESTS";
export const ADD_INTERESTS = "ADD_INTERESTS";
export const UPDATE_INTERESTS = "UPDATE_INTERESTS";
export const UPDATE_ACHIEVEMENTS = "UPDATE_ACHIEVEMENTS";
export const ADD_ACHIEVEMENTS = "ADD_ACHIEVEMENTS";
export const UPDATE_TAGS = "UPDATE_TAGS";
export const GET_TAGS = "GET_TAGS";
export const GET_TAGS_VIEW = "GET_TAGS_VIEW";
export const ADD_TAGS = "ADD_TAGS";
export const GET_PROFILE_PIC = "GET_PROFILE_PIC";
export const UPDATE_PROFILE_PIC = "UPDATE_PROFILE_PIC";
export const GET_GROUPS = "GET_GROUPS";
export const GET_CLASSES = "GET_CLASSES";
export const GET_CLASS_DETAILS = "GET_CLASS_DETAILS";
export const GET_GROUP_DETAILS = "GET_GROUP_DETAILS";
export const POST_CLASS_DETAILS = "POST_CLASS_DETAILS";
export const PUT_CLASS_DETAILS = "PUT_CLASS_DETAILS";
export const POST_GROUP_DETAILS = "POST_GROUP_DETAILS";
export const UPDATE_ABOUT = "UPDATE_ABOUT";
export const GET_ABOUT = "GET_ABOUT";
export const GET_PROFILE_DATA_EDIT = "GET_PROFILE_DATA_EDIT";
export const GET_PROFILE_DATA_VIEW = "GET_PROFILE_DATA_VIEW";
export const GET_PEOPLE_YOU_MAY_KNOW = "GET_PEOPLE_YOU_MAY_KNOW";
export const GET_PEOPLE_YOU_MAY_KNOW_VIEW = "GET_PEOPLE_YOU_MAY_KNOW_VIEW";
export const POST_COURSE_DETAILS = "POST_COURSE_DETAILS";
export const POST_MEMBERS_DETAILS = "POST_MEMBERS_DETAILS";
export const EDIT_PROFILE_DATA = "EDIT_PROFILE_DATA";
export const UPDATE_GROUP_COVER = "UPDATE_GROUP_COVER";

export const GET_COVER_PIC = "GET_COVER_PIC";
export const UPDATE_COVER_PIC = "UPDATE_COVER_PIC";
export const GET_DASHBOARD_POST = "GET_POST";
export const POST_LIKE = "POST_LIKE";
export const COMMENT_LIKE = "COMMENT_LIKE";
export const POST_COMMENT = "POST_COMMENT";
export const POST_DISLIKE = "POST_DISLIKE";
export const COMMENT_DISLIKE = "COMMENT_DISLIKE";
export const GET_USER_SUGGESTIONS = "GET_USER_SUGGESTIONS";
export const HEADER = "HEADER";
export const CLASS_ID_BY_CODE = "CLASS_ID_BY_CODE";

export const MEET_SUCCESS = "MEET_SUCCESS";
export const MEET_FAILURE = "MEET_FAILURE";
export const UPDATE_SOCIAL_LINKS = "UPDATE_SOCIAL_LINKS";
export const ADD_SOCIAL_LINKS = "ADD_SOCIAL_LINKS";
export const CHANGE_CLASS_ACTIVE_SECTION = "CHANGE_CLASS_ACTIVE_SECTION";
export const CHANGE_GROUP_ACTIVE_SECTION = "CHANGE_GROUP_ACTIVE_SECTION";

export const FETCH_SEARCH_RESULTS = "FETCH_SEARCH_RESULTS";

// export const FETCH_SEARCH_RESULTS = "FETCH_SEARCH_RESULTS"

export const SENT_CONNECTIONS = "SENT_CONNECTIONS";
export const CONNECTION_INVITATION = "CONNECTION_INVITATION";
export const ACCPET_CONNECTION = "ACCPET_CONNECTION";
export const MY_CONNECTIONS = "MY_CONNECTIONS";
export const WITHDRAW_CONNECTION = "WITHDRAW_CONNECTION";
export const REMOVE_CONNECTION = "REMOVE_CONNECTION";
export const IGNORE_CONNECTION = "IGNORE_CONNECTION";
export const SEND_CONNECTION = "SEND_CONNECTION";
export const GET_SUCCESS_MESSAGE = "GET_SUCCESS_MESSAGE";
export const POST_MISSION = "POST_MISSION";
export const POST_GROUP_MISSION = "POST_GROUP_MISSION";

export const DELETE_MEMBER = "DELETE_MEMBER";
export const GET_USER_SETTINGS = "GET_USER_SETTINGS";
export const PUT_USER_SETTINGS = "PUT_USER_SETTINGS";

export const GET_CODE_SUGGESTIONS = "GET_CODE_SUGGESTIONS";
export const PUT_TIME_TABLE = "PUT_TIME_TABLE";
export const PUT_GROUP_DETAILS = "PUT_GROUP_DETAILS";

export const PAYMENT_CREATE = "PAYMENT_CREATE";
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
export const PAYMENT_FAILURE = "PAYMENT_FAILURE";

export const TRANSLATE_DATA = "TRANSLATE_DATA";
export const CHANGE_CURRENT_LANGUAGE = "CHANGE_CURRENT_LANGUAGE";
export const RESET_ERROR_MESSAGE = "RESET_ERROR_MESSAGE";
export const SIGNUP_STATUS = "SIGNUP_STATUS";
export const DELETE_CLASS = "DELETE_CLASS";
export const DELETE_GROUP = "DELETE_GROUP";
export const GET_CLASS_POST = "GET_CLASS_POST";
export const GET_GROUP_POST = "GET_GROUP_POST";

export const SEARCH_PAGINATED_RESULT = "SEARCH_PAGINATED_RESULT";
/* getActiveClassDetails={this.props.getActiveClassDetails}
Feed context Line:105
this.props.getActiveClassDetails(this.props.class_id); 
file_url.split("/").pop()
*/

// Assignment-actions

export const GET_INDIVIDUAL_ASSIGNMENT = "GET_INDIVIDUAL_ASSIGNMENT";
export const GET_ALL_ASSIGNMENTS = "GET_ALL_ASSIGNMENTS";

export const CREATE_CLASS_ASSIGNMENT = "CREATE_CLASS_ASSIGNMENT";
export const UPDATE_CLASS_ASSIGNMENT = "UPDATE_CLASS_ASSIGNMENT";
export const DELETE_CLASS_ASSIGNMENT = "DELETE_CLASS_ASSIGNMENT";

export const GET_ASSIGNMENT_PAGE = "GET_ASSIGNMENT_PAGE";
export const GET_ASSIGNMENT_SUBMISSION = "GET_ASSIGNMENT_SUBMISSION";
export const POST_CREATE_ASSIGNMENT_SUBMISSION =
  "POST_CREATE_ASSIGNMENT_SUBMISSION";

export const PUT_ASSIGNMENT_SUBMISSION_UPDATE =
  "PUT_ASSIGNMENT_SUBMISSION_UPDATE";

export const NEW_REQUEST_FOR_ASSIGNMENT_SUBMISSION =
  "NEW_REQUEST_FOR_ASSIGNMENT_SUBMISSION";

export const GET_STUDENT_LIST = "GET_STUDENT_LIST";

// Quiz-actions

export const GET_STUDENT_ASSIGNMENT_LIST = "GET_STUDENT_ASSIGNMENT_LIST";
export const GET_STUDENT_INDIVIDUAL_ASSIGNMENT =
  "STUDENT_INDIVIDUAL_ASSIGNMENT";
export const SUBMIT_ASSIGNMENT_SOLUTION = "SUBMIT_ASSIGNMENT_SOLUTION";
export const GET_STUDENT_SUBMISSION = "GET_STUDENT_SUBMISSION";
export const UPDATE_STUDENT_ASSIGNMENT_SOLUTION =
  "UPDATE_STUDENT_ASSIGNMENT_SOLUTION";
export const SAVE_ASSIGNMENT_MARKS = "SAVE_ASSIGNMENT_MARKS";
// export const GET_STUDENT_SUBMISSION = "GET_STUDENT_SUBMISSION";
export const GET_ALL_ASSIGNMENT_SUBMISSIONS = "GET_ALL_ASSIGNMENT_SUBMISSIONS";
export const GET_INDIVIDUAL_ASSIGNMENT_SUBMISSION =
  "GET_INDIVIDUAL_ASSIGNMENT_SUBMISSION";
export const GET_ALL_FILTERED_ASSIGNMENT_SUBMISSIONS =
  "GET_ALL_FILTERED_ASSIGNMENT_SUBMISSIONS";

export const ADD_PRIVATE_COMMENT = "ADD_PRIVATE_COMMENT";
export const DISPLAY_PRIVATE_COMMENT_ASSIGNMENT = "DISPLAY_PRIVATE_COMMENT_ASSIGNMENT";
export const DISPLAY_PRIVATE_COMMENT_QUIZ = "DISPLAY_PRIVATE_COMMENT_QUIZ";
export const REMOVE_STUDENT_SUBMISSION = "REMOVE_STUDENT_SUBMISSION";
export const GET_QUIZ_LIST = "GET_QUIZ_LIST";
export const GET_STUDENT_INDIVIDUAL_QUIZ = "GET_STUDENT_INDIVIDUAL_QUIZ";
export const GET_STUDENT_QUIZ_SUBMISSION = "GET_STUDENT_QUIZ_SUBMISSION";
export const SUBMIT_QUIZ_SOLUTION = "SUBMIT_QUIZ_SOLUTION";
export const UPDATE_STUDENT_QUIZ_SOLUTION = "UPDATE_STUDENT_QUIZ_SOLUTION";

export const CREATE_CLASS_QUIZ = "CREATE_CLASS_QUIZ";
export const GET_INDIVIDUAL_QUIZ = "GET_INDIVIDUAL_QUIZ";
export const UPDATE_CLASS_QUIZ = "UPDATE_CLASS_QUIZ";
export const DELETE_CLASS_QUIZ = "DELETE_CLASS_QUIZ";
export const GET_QUIZ_STUDENT_LIST = "GET_QUIZ_STUDENT_LIST";
export const RETURN_QUIZ_MARKS = "RETURN_QUIZ_MARKS";
export const SAVE_QUIZ_MARKS = "SAVE_QUIZ_MARKS";

export const GET_ALL_QUIZ_SUBMISSIONS = "GET_ALL_QUIZ_SUBMISSIONS";
export const GET_INDIVIDUAL_QUIZ_SUBMISSIONS =
  "GET_INDIVIDUAL_QUIZ_SUBMISSIONS";
export const GET_ALL_FILTERED_QUIZ_SUBMISSIONS =
  "GET_ALL_FILTERED_QUIZ_SUBMISSIONS";
export const RETURN_ASSIGNMENT_MARKS = "RETURN_ASSIGNMENT_MARKS";
export const GET_STUDENT_QUIZ_LIST = "GET_STUDENT_QUIZ_LIST";
export const PROGRESS_BAR_COUNT_ASG = "PROGRESS_BAR_COUNT_ASG";
export const PROGRESS_BAR_COUNT_QUIZ = "PROGRESS_BAR_COUNT_QUIZ";
export const GET_ALL_ASSIGNMENT_QUIZ = "GET_ALL_ASSIGNMENT_QUIZ";
export const IS_LOADING = "IS_LOADING";
export const IS_LOADING_QUIZ = "IS_LOADING_QUIZ";
export const ERROR_STATUS_CODE= "ERROR_STATUS_CODE";
export const GET_ALL_CLASS_OWNER_CODES = "GET_ALL_CLASS_OWNER_CODES";
export const GET_ALL_GROUP_OWNER_CODES = "GET_ALL_GROUP_OWNER_CODES";
export const CLEAR_ASSIGNMENT_SUBMISSION = "CLEAR_ASSIGNMENT_SUBMISSION";
export const CLEAR_QUIZ_SUBMISSION = "CLEAR_QUIZ_SUBMISSION";

export const GET_ALL_COURSES = "GET_ALL_COURSES";
export const CREATE_COURSE = "CREATE_COURSE";
export const EDIT_COURSE = "EDIT_COURSE";

export const GET_ALL_CREATED_COURSES = "GET_ALL_CREATED_COURSES";
export const CLEAR_ALL_COURSES = "CLEAR_ALL_COURSES";
export const DELETE_COURSE = "DELETE_COURSE";
export const DELETE_COURSE_QUIZ = "DELETE_COURSE_QUIZ";
export const UPDATE_COURSE_STATUS = "UPDATE_COURSE_STATUS";
export const ENROLL_COURSE = "ENROLL_COURSE";
export const GET_COURSE = "GET_COURSE"
export const GET_COURSE_FEED = "GET_COURSE_FEED";
export const GET_PUBLIC_COURSES = "GET_PUBLIC_COURSES";
export const GET_ENROLLED_COURSES = "GET_ENROLLED_COURSES";


export const PAYMENT_CREATE_COURSE = "PAYMENT_CREATE_COURSE";
export const UPDATE_CURRENT_COURSE_STATUS = "UPDATE_CURRENT_COURSE_STATUS";
export const GET_INDIVIDUAL_ASSIGNMENT_SUBMISSION_ID = "GET_INDIVIDUAL_ASSIGNMENT_SUBMISSION_ID";
export const ASSIGN_STUDENTS_TO_ASSIGNMENT = "ASSIGN_STUDENTS_TO_ASSIGNMENT";
export const UNASSIGN_STUDENTS_FROM_ASSIGNMENT = "UNASSIGN_STUDENTS_FROM_ASSIGNMENT";
export const GRADE_ZERO = "GRADE_ZERO";
export const GET_INDIVIDUAL_ASSIGNMENT_PRE_SUBMISSION_DATA = "GET_INDIVIDUAL_ASSIGNMENT_PRE_SUBMISSION_DATA";


export const GET_COURSE_CONTENT = "GET_COURSE_CONTENT";
export const MARK_AS_COMPLETED = "MARK_AS_COMPLETED"; 
export const MARK_AS_UNCOMPLETED = "MARK_AS_UNCOMPLETED";
export const GET_COURSE_PROGRESS = "GET_COURSE_PROGRESS";

export const CREATE_SECTION = "CREATE_SECTION";
export const UPDATE_SECTION = "UPDATE_SECTION";
export const DELETE_SECTION = "DELETE_SECTION";

export const CREATE_LECTURE = "CREATE_LECTURE";
export const UPDATE_LECTURE = "UPDATE_LECTURE";
export const DELETE_LECTURE = "DELETE_LECTURE";

export const UPDATE_COURSE = "UPDATE_COURSE";

// enhanced Quiz 

export const CREATE_QUIZ_TEMPLATE = "CREATE_QUIZ_TEMPLATE";
export const CREATE_QUIZ = "CREATE_QUIZ";
export const GET_ALL_QUIZ_TEMPLATES = "GET_ALL_QUIZ_TEMPLATES";
export const GET_ALL_QUIZZES = "GET_ALL_QUIZZES";
export const GET_INDIVIDUAL_QUIZ_TEMPLATE = "GET_INDIVIDUAL_QUIZ_TEMPLATE";
export const DELETE_QUIZ_TEMPLATE = "DELETE_QUIZ_TEMPLATE";
export const UPDATE_QUIZ_TEMPLATE = "UPDATE_QUIZ_TEMPLATE";
export const DELETE_QUIZ = "DELETE_QUIZ";
export const UPDATE_QUIZ = "UPDATE_QUIZ";
export const ATTEMPT_QUIZ = "ATTEMPT_QUIZ";
export const UPDATE_QUIZ_MARKS = "UPDATE_QUIZ_MARKS";
export const GET_LLM_QUIZ_QUESTIONS = "GET_LLM_QUIZ_QUESTIONS"


// ---- gradebook ------

export const GET_ALL_STUDENT_DETAILS = "GET_ALL_STUDENT_DETAILS";
export const GET_ASSIGNMENT_QUIZ_RESULTS = "GET_ASSIGNMENT_QUIZ_RESULTS";
export const DOWNLOAD_STUDENT_LIST = "DOWNLOAD_STUDENT_LIST"
export const DOWNLOAD_GRADEBOOK = "DOWNLOAD_GRADEBOOK";
export const DOWNLOAD_INDIVIDUAL_QUIZ = "DOWNLOAD_INDIVIDUAL_QUIZ";
export const DOWNLOAD_INDIVIDUAL_ASSIGNMENT = "DOWNLOAD_INDIVIDUAL_ASSIGNMENT";


// ----- boostProfile / boostPost ---------

export const GET_MY_POSTS = "GET_MY_POSTS";
export const BOOST_MY_POST = "BOOST_MY_POST";
export const BOOST_MY_PROFILE = "BOOST_MY_PROFILE";
export const REMOVE_EXISTING_PAYMENT_ORDER = "REMOVE_EXISTING_PAYMENT_ORDER";

export const ADD_PUBLICATION = "ADD_PUBLICATION";
export const UPDATE_PUBLICATION = "UPDATE_PUBLICATION"

export const ADD_TRAINING = "ADD_TRAINING";
export const UPDATE_TRAINING = "UPDATE_TRAINING"

export const ADD_RESEARCH = "ADD_RESEARCH";
export const UPDATE_RESEARCH = "UPDATE_RESEARCH"

export const ADD_PROJECT = "ADD_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT"


// ----------- liveChat -----------------------

export const SEND_MESSAGE = "SEND_MESSAGE";
export const GET_CHAT_LIST = "GET_CHAT_LIST";
export const UPDATE_CHAT_LIST = "UPDATE_CHAT_LIST";
export const GET_CHAT_MESSAGES = "GET_CHAT_MESSAGES";
export const UPDATE_CHAT_MESSAGE = "UPDATE_CHAT_MESSAGE";
export const UPDATE_CHAT_MESSAGES = "UPDATE_CHAT_MESSAGES";
export const GET_SEARCH_RESULT = "GET_SEARCH_RESULT";
export const CREATE_CHANNEL = "CREATE_CHANNEL";
export const DELETE_CHAT_CHANNEL = "DELETE_CHAT_CHANNEL";
export const CLEAR_CHAT_HISTORY = "CLEAR_CHAT_HISTORY";
export const DELETE_SELECTED_MESSAGES = "DELETE_SELECTED_MESSAGES"



// ----------- enterpriseDashboard -----------------------

export const GET_DASHBOARD_FACULTY = "GET_DASHBOARD_FACULTY";
export const GET_DASHBOARD_STUDENT = "GET_DASHBOARD_STUDENT";
export const GET_DASHBOARD_POSTS = "GET_DASHBOARD_POSTS";
export const GET_DASHBOARD_CLASS = "GET_DASHBOARD_CLASS";
export const GET_DASHBOARD_GROUP = "GET_DASHBOARD_GROUP";
export const GET_DASHBOARD_CLASS_LIST = "GET_DASHBOARD_CLASS_LIST";
export const GET_DASHBOARD_GROUP_LIST = "GET_DASHBOARD_GROUP_LIST";

export const GET_DASHBOARD_CLASS_POST = "GET_DASHBOARD_CLASS_POST";
export const GET_DASHBOARD_CLASS_ASSIGNMENT = "GET_DASHBOARD_CLASS_ASSIGNMENT";
export const GET_DASHBOARD_CLASS_QUIZ = "GET_DASHBOARD_CLASS_QUIZ";
export const GET_DASHBOARD_CLASS_COURSE = "GET_DASHBOARD_CLASS_COURSE";

export const GET_DASHBOARD_GROUP_POST = "GET_DASHBOARD_GROUP_POST";
export const GET_DASHBOARD_GROUP_ASSIGNMENT = "GET_DASHBOARD_GROUP_ASSIGNMENT";
export const GET_DASHBOARD_GROUP_QUIZ = "GET_DASHBOARD_GROUP_QUIZ";

export const GET_DASHBOARD_DATA_COUNT = "GET_DASHBOARD_DATA_COUNT";
export const GET_DASHBOARD_CHART_DATA = "GET_DASHBOARD_CHART_DATA";
export const GET_DASHBOARD_SEARCH_RESULT = "GET_DASHBOARD_SEARCH_RESULT"; 


// ------------- Faculty only Dashboard --------------------


export const GET_FACULTYDASHBOARD_DATA_COUNT = "GET_FACULTYDASHBOARD_DATA_COUNT";
export const GET_FACULTYDASHBOARD_CHART_DATA = "GET_FACULTYDASHBOARD_CHART_DATA";

export const GET_FACULTYDASHBOARD_CLASS_ASSIGNMENT = "GET_FACULTYDASHBOARD_CLASS_ASSIGNMENT";
export const GET_FACULTYDASHBOARD_CLASS_POST = "GET_FACULTYDASHBOARD_CLASS_POST";
export const GET_FACULTYDASHBOARD_CLASS_QUIZ = "GET_FACULTYDASHBOARD_CLASS_QUIZ";
export const GET_FACULTYDASHBOARD_CLASS_COURSE = "GET_FACULTYDASHBOARD_CLASS_COURSE";

export const GET_FACULTYDASHBOARD_GROUP_POST = "GET_FACULTYDASHBOARD_GROUP_POST";
export const GET_FACULTYDASHBOARD_GROUP_ASSIGNMENT = "GET_FACULTYDASHBOARD_GROUP_ASSIGNMENT";
export const GET_FACULTYDASHBOARD_GROUP_QUIZ = "GET_FACULTYDASHBOARD_GROUP_QUIZ";


export const GET_FACULTYDASHBOARD_CLASS_LIST = "GET_FACULTYDASHBOARD_CLASS_LIST";
export const GET_FACULTYDASHBOARD_GROUP_LIST = "GET_FACULTYDASHBOARD_GROUP_LIST";


export const GET_FACULTYDASHBOARD_SEARCH_RESULT = "GET_FACULTYDASHBOARD_SEARCH_RESULT";

export const GET_FACULTYDASHBOARD_CLASS_STUDENT = "GET_FACULTYDASHBOARD_CLASS_STUDENT";
export const GET_FACULTYDASHBOARD_GROUP_MEMBER = "GET_FACULTYDASHBOARD_GROUP_MEMBER";
export const CLEAR_FACULTYDASHBOARD = "CLEAR_FACULTYDASHBOARD";


//  ------------------- Student only Dashboard --------------

export const GET_STUDENTDASHBOARD_DATA_COUNT = "GET_STUDENTDASHBOARD_DATA_COUNT";
export const GET_STUDENTDASHBOARD_CHART_DATA = "GET_STUDENTDASHBOARD_CHART_DATA";

export const GET_STUDENTDASHBOARD_CLASS_ASSIGNMENT = "GET_STUDENTDASHBOARD_CLASS_ASSIGNMENT";
export const GET_STUDENTDASHBOARD_CLASS_POST = "GET_STUDENTDASHBOARD_CLASS_POST";
export const GET_STUDENTDASHBOARD_CLASS_QUIZ = "GET_STUDENTDASHBOARD_CLASS_QUIZ";
export const GET_STUDENTDASHBOARD_CLASS_COURSE = "GET_STUDENTDASHBOARD_CLASS_COURSE";

export const GET_STUDENTDASHBOARD_GROUP_POST = "GET_STUDENTDASHBOARD_GROUP_POST";
export const GET_STUDENTDASHBOARD_GROUP_ASSIGNMENT = "GET_STUDENTDASHBOARD_GROUP_ASSIGNMENT";
export const GET_STUDENTDASHBOARD_GROUP_QUIZ = "GET_STUDENTDASHBOARD_GROUP_QUIZ";

export const GET_STUDENTDASHBOARD_CLASS_LIST = "GET_STUDENTDASHBOARD_CLASS_LIST";
export const GET_STUDENTDASHBOARD_GROUP_LIST = "GET_STUDENTDASHBOARD_GROUP_LIST";

export const GET_STUDENTDASHBOARD_SEARCH_RESULT = "GET_STUDENTDASHBOARD_SEARCH_RESULT";


export const GET_DROPDOWN_CATEGORIES = "GET_DROPDOWN_CATEGORIES";

export const GET_OPPORTUNITIES_FILTER_RESULT = "GET_OPPORTUNITIES_FILTER_RESULT";


// ------------- Mindfulness --------------------

// Creator Session
export const CREATE_CREATOR_SESSION = "CREATE_CREATOR_SESSION";
export const GET_ALL_CREATOR_SESSIONS = "GET_ALL_CREATOR_SESSIONS";
export const GET_ALL_CREATORS = "GET_ALL_CREATORS";
export const GET_CREATOR_SESSION_BY_ID = "GET_CREATOR_SESSION_BY_ID";
export const UPDATE_CREATOR_SESSION = "UPDATE_CREATOR_SESSION";
export const DELETE_CREATOR_SESSION = "DELETE_CREATOR_SESSION";

// Creator Availability
export const CREATE_CREATOR_AVAILABILITY = "CREATE_CREATOR_AVAILABILITY";
export const GET_CREATOR_AVAILABILITY = "GET_CREATOR_AVAILABILITY";
export const UPDATE_CREATOR_AVAILABILITY = "UPDATE_CREATOR_AVAILABILITY";
export const DELETE_CREATOR_AVAILABILITY = "DELETE_CREATOR_AVAILABILITY";

// Bookings
export const CREATE_BOOKING = "CREATE_BOOKING";
export const GET_CREATOR_BOOKINGS = "GET_CREATOR_BOOKINGS";
export const GET_CREATOR_BOOKING = "GET_CREATOR_BOOKING";
export const GET_USER_BOOKINGS = "GET_USER_BOOKINGS";
export const GET_BOOKING_BY_ID = "GET_BOOKING_BY_ID";
export const UPDATE_BOOKING = "UPDATE_BOOKING";
export const DELETE_BOOKING = "DELETE_BOOKING";
export const GET_AVAILABLE_TIME_SLOTS = "GET_AVAILABLE_TIME_SLOTS";

// Session Rating
export const CREATE_SESSION_RATING = "CREATE_SESSION_RATING";
export const GET_SESSION_RATINGS = "GET_SESSION_RATINGS";
export const UPDATE_SESSION_RATING = "UPDATE_SESSION_RATING";

// Creator Dashboard
export const GET_CREATOR_DASHBOARD = "GET_CREATOR_DASHBOARD";
export const GET_USER_DASHBOARD = "GET_USER_DASHBOARD";

// Loading and Error states
export const MINDFULNESS_LOADING = "MINDFULNESS_LOADING";
export const MINDFULNESS_ERROR = "MINDFULNESS_ERROR";

export const SEARCH_SESSION_WITH_FILTERS = "SEARCH_SESSION_WITH_FILTERS";

export const CREATOR_STATUS_UPDATE = "CREATOR_STATUS_UPDATE";



